const routes = {
  new: [
    {
      path: "/reasons",
      layout: "guest",
      redirect: { name: "reasons-1" },
      children: [
        {
          path: "1",
          name: "reasons-1",
          component: () => import("../pages/reasons/reasons-1.vue"),
          meta: {
            pageTitle: "Reasons to invest",
            breadcrumbs: ["Available deals"],
          },
        },
        {
          path: "2",
          name: "reasons-2",
          component: () => import("../pages/reasons/reasons-2.vue"),
          meta: {
            pageTitle: "Reasons to invest",
            breadcrumbs: ["Available deals"],
          },
        },
        {
          path: "3",
          name: "reasons-3",
          component: () => import("../pages/reasons/reasons-3.vue"),
          meta: {
            pageTitle: "Reasons to invest",
            breadcrumbs: ["Available deals"],
          },
        },
      ],
    },
  ],

  existing: [],

  disabled: [
    { path: "/proposal" },
    { path: "/investor" },
    { path: "/intermediary" },
  ],
};

export default routes;
